<template>
  <Drawer width="400" v-model="drawerOpened" class="CreateSemiItemDrawer" title="母液项目">
    <div class="wrap">
      <div class="drawer-content">
        <Form label-position="top" :rules="ruleValidate" :model="formItem" ref="formItem" @submit.native.prevent>
          <FormItem label="母液" prop="material" style="width: 366px">
            <Select v-model="formItem.material" filterable remote style="width: 350px" :loading="semiMaterialLoading"
              placeholder="选择母液" @on-change="selectSemiChange" :disabled="openedSemiItem ? true : false" clearable>
              <Option v-for="option in semiMaterials" :value="option._id" :key="option._id" style="width: 350px">{{
                option.model }}</Option>
            </Select>
          </FormItem>
          <FormItem label="工厂" prop="factory" style="width: 366px">
            <Select v-model="formItem.factory" filterable remote style="width: 350px"
              :disabled="openedSemiItem ? true : false" :loading="factoryLoading" placeholder="选择工厂">
              <Option v-for="option in factoryList" :value="option._id" :key="option._id" style="width: 350px">{{
                option.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="自产母液" prop="selfProductSemi">
            <i-switch v-model="isSelfProductSemi" @on-change="changeSelfProductSemi"></i-switch>
          </FormItem>
          <FormItem label="禁用" prop="invalid">
            <i-switch v-model="isInvalid" true-color="#ff4949" @on-change="changeInvalid"></i-switch>
          </FormItem>
          <FormItem label="金蝶云代码" prop="JDItemCode">
            <Input v-model="formItem.JDItemCode" placeholder="输入金蝶云代码..." />
          </FormItem>
          <div v-if="!isSelfProductSemi">
            <FormItem label="母液生产的工厂" prop="fromFactory" style="width: 366px">
              <Select v-model="formItem.fromSemiItem" filterable remote style="width: 350px"
                :loading="fromFactoryLoading" placeholder="选择工厂" ref="selectFromFactory">
                <Option v-for="option in produceFactoryList" :value="option._id" :key="option.factory._id"
                  style="width: 350px">{{ option.factory.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="母液从生产工厂到本厂的运费" prop="fromFactoryCost">
              <div class="transCost">
                <InputNumber v-model="formItem.importSemiTransCost" :min="0" />
              </div>
            </FormItem>
          </div>

          <FormItem>
            <Button type="primary" @click="handleSubmit('formItem')">创建</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateSemiItemDrawer",
  data() {
    return {
      openedSemiItem: null,
      drawerOpened: false,
      semiMaterialLoading: false,
      factoryLoading: false,
      fromFactoryLoading: false,
      fromFactoryCostLoading: false,
      isSelfProductSemi: false,
      isInvalid: false,

      produceFactoryList: null,
      formItem: {
        material: undefined,
        factory: undefined,
        importSemiTransCost: undefined,
        fromSemiItem: null,
        invalid: null,
        JDItemCode: "",
      },
      ruleValidate: {
        material: [
          { required: true, message: "母液为必填项", trigger: "submit" },
        ],
        factory: [
          { required: true, message: "工厂为必填项", trigger: "submit" },
        ],
      },
      semiFilterQuery: { type: "semi", limit: 99, skip: 0 },
    };
  },
  computed: {
    ...mapState({
      semiMaterials: (state) => state.material.materials,
      factoryList: (state) => state.factory.factoryList,
    }),
  },
  methods: {
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      getSemiProduceFactory: "semiItem/getSemiProduceFactoryAction",
      createSemiItem: "semiItem/createSemiItemAction",
      updateSemiItem: "semiItem/updateSemiItemAction",
      getFactorys: "factory/getFactorysAction",
    }),
    async openDrawer(semiItem) {
      this.semiMaterialLoading = true;
      await this.getMaterials(this.semiFilterQuery);
      this.semiMaterialLoading = false;
      this.factoryLoading = true;
      await this.getFactorys();
      this.factoryLoading = false;
      this.$refs["formItem"].resetFields();
      this.openedSemiItem = semiItem;
      if (semiItem) {
        this.formItem.material = semiItem.material._id;
        const produceFactory = await this.getSemiProduceFactory(
          semiItem.material._id
        );
        this.produceFactoryList = produceFactory;
        this.formItem.factory = semiItem.factory._id;
        this.formItem.importSemiTransCost = semiItem.importSemiTransCost;
        this.formItem.invalid = semiItem.invalid;
        this.formItem.JDItemCode = semiItem.JDItemCode || "";
        this.isInvalid = semiItem.invalid;
        if (semiItem.fromSemiItem) {
          this.isSelfProductSemi = false;
          this.formItem.fromSemiItem = semiItem.fromSemiItem._id;
        } else {
          this.isSelfProductSemi = true;
        }
      }
      this.drawerOpened = true;
    },
    // 选择母液后获取母液生产的工厂
    async selectSemiChange(options) {
      if (options) {
        if (!this.isSelfProductSemi) {
          this.produceFactoryList = [];
          this.$refs.selectFromFactory.clearSingleSelect();
        }
        const produceFactory = await this.getSemiProduceFactory(options);
        this.produceFactoryList = produceFactory;
      }
    },
    // 改变是否自产母液
    changeSelfProductSemi(status) {
      if (status) {
        this.formItem.fromSemiItem = null;
        delete this.formItem.importSemiTransCost;
      }
    },
    // 是否禁用母液
    changeInvalid(status) {
      this.formItem.invalid = status;
      this.isInvalid = status;
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSemiItem) {
              await this.updateSemiItem({
                id: this.openedSemiItem._id,
                data: {
                  ...this.formItem,
                },
              });
            } else {
              await this.createSemiItem({ ...this.formItem });
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>